export const numberTitle = "Mobile Number:";
export const telcoTitle = "Telco:";
export const productsTitle = "Available Products:";
export const amountTitle = "Amount:";
